'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var BorderlessButton = require('../BorderlessButton/BorderlessButton.js');

var ButtonGroup = function (_a) {
    var buttons = _a.buttons;
    if (buttons.length < 2) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var firstButtonData = buttons[0];
    var lastButtonData = buttons.pop();
    var middleButtonData = buttons.slice(1);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BorderlessButton, tslib.__assign({}, firstButtonData, { style: { borderRadius: '0px', borderRight: '1px solid #e3ebf6', paddingRight: '13px' } })),
        middleButtonData.map(function (buttonData) { return (React__default.createElement(BorderlessButton, tslib.__assign({ key: buttonData.title }, buttonData, { style: {
                borderRadius: '0px',
                borderRight: '1px solid #e3ebf6',
                paddingRight: '13px',
                paddingLeft: '13px',
            } }))); }),
        React__default.createElement(BorderlessButton, tslib.__assign({}, lastButtonData, { style: { borderRadius: '0px', paddingRight: '13px' } }))));
};

module.exports = ButtonGroup;
